module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_5012.a4f72757.png";